import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles({
  costCapSpoilerTitle: {
    marginLeft: 'unset',
    '&:before': {
      marginRight: 12
    }
  }
})

export default useStyles
